import QuoteTable from '../modules/quote_table/index'
import delayparams from '../modules/url/delayQuote';

declare var MobileSelect;
declare var Swiper;

let data = {
    newclass: null,
    timer:null,
    pz_size:10,
    quoteConfig: {
        host: '//push2.eastmoney.com',
        unpPath: '/api/qt/ulist.np/get',
        token: 'f057cbcbce2a86e2866ab8877db1d059',
        cPath: '/api/qt/clist/get',
        fs:[
            'm:1+e:97,m:0+e:97', // 全部市场
            'm:1+e:97', // 上交所REITS
            'm:0+e:97', // 深交所REITS
        ]
    },
    refresh_time: 10,
    fs_index:'m:1+e:97,m:0+e:97',
    // 初始化
    init: function () {
        let self = this
        self.table = self.makeQuoteTable()
        self.mobileSelectInit()
        $('.hsphb-more').on('click',async function(){
            try {
                let data = await self.table.showMore(20)
                self.pz_size +=20
                let dataNum = data.data.diff.length
                if(self.pz_size > dataNum){
                    $(".hsphb-more").html('已经到底了')
                }
            } catch (error) {
                $(".hsphb-more").html('暂无数据')
            }
        })
        self.autoFix(0)
    },
    autoFix: function (val) {
      var scTop = 0 //初始化垂直滚动的距离
      $(".hqzx-usa").css("top", val)
  
      $(document).off("scroll")
      $(document).scroll(function () {
        var banOffTop1 = $("#title-fixed-container").offset().top //获取到距离顶部的垂直距离\
        var banOffTop2 = $("#hsphb").offset().top
        var banOffHeight1 = $("#title-fixed-container").height()
        if (banOffHeight1) {
          var fixedHeight1 = $(".hqzx-usa").height() + val + 20
          var fixedHeight2 = fixedHeight1 + $("#title-fixed-container").height()
          scTop = $(this).scrollTop() //获取到滚动条拉动的距离
          if (scTop >= banOffTop1) {
            $("#title-fixed-container").addClass("title-fix")
          } else {
            $("#title-fixed-container").removeClass("title-fix")
          }
          if (scTop >= banOffTop2 - banOffHeight1 - 10 && $("#hsphb").find("div")[0]) {
            $("#hsphb").find("div")[0].classList.add("table-title-fix")
            $("#hsphb").children("div")[0].style.top = fixedHeight2 - 25 + "px"
            $("#title-fixed-container").addClass("table-title-fix-new")
            $("#hsphb").children("div")[1].style.marginTop = "3rem"
          } else if (scTop < banOffTop2 - banOffHeight1 - 10 && $("#hsphb").find("div")[0]) {
            $("#hsphb").find("div")[0].classList.remove("table-title-fix")
            $("#title-fixed-container").removeClass("table-title-fix-new")
            $("#hsphb").children("div")[1].style.marginTop = "0"
          }
        }
      })
    },
    makeQuoteTable: function () {
        let self = this
        let quotetable = new QuoteTable({
            ele: 'hsphb',
            api: `//push2.eastmoney.com/api/qt/clist/get?cb=?&pn=1&np=1&ut=8a086bfc3570bdde64a6a1c585cccb35&fltt=1&invt=1&fs=${self.fs_index}&dpt=zqsc.zpg&fields=f1,f2,f3,f4,f5,f6,f8,f10,f12,f13,f14,f15,f16,f18,f22,f30,f152${delayparams}`,
            params: { // 默认参数配置
                sortkey: 'f3',
                sortval: '1',
                size: '20'
            },
            right_tds: 3,
            refresh: 15,
            sortdesc:'1',
            sortasc:'0',
            item: [
                {
                    name: 'name',
                    title: '名称',
                    html: function (data) {
                        if (data == null) {
                            return `<th>${this.title}</th>`
                        } else {
                            let icon = ''
                            if ((data.f13 == 1) && (data.f19 == 23)) {
                                icon = icon + "<span class='icon-kc'>科创</span>"
                            }
                            if ((data.f13 == 0) && (data.f111 & 2048)){
                                icon = icon + "<span class='icon-kc'>京</span>"
                            }
                            if (data.f148 & 64) {
                                icon = icon + "<span class='icon-rz'>融</span>"
                            }
                            return `<td><p>${data.f14}</p><p>${data.f12}${icon}</p></td>`
                        }
                    },
                    sort: false
                },
                {
                    name: 'zx',
                    title: '最新',
                    html: function (data) {
                        if (data == null) {
                            return `<th value="true" class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3 < 0?'shares-fall':'') }">${self.formatNum(data.f2,data.f1,3)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f2'
                    }
                },
                {
                    name: 'zf',
                    title: '涨幅',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_des">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3 < 0?'shares-fall':'') }">${self.formatNum(data.f3,data.f152, data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '0',
                        ascvalue: '1',
                        key: 'f3'
                    }
                },
                {
                    name: 'zs',
                    title: '总手',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.formatZS(data.f5,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f5'
                    }
                },
                {
                    name: 'zd',
                    title: '涨跌',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0?'shares-fall':'') }">${self.formatNum(data.f4,data.f1,3)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f4'
                    }
                },
                {
                    name: 'zs',
                    title: '涨速',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f22 > 0 ? 'shares-rise' : (data.f22 < 0?'shares-fall':'') }">${self.formatNum(data.f22,data.f152,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f22'
                    }
                },
                {
                    name: 'xs',
                    title: '现手',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f30 > 0 ? 'shares-rise' : (data.f30 < 0?'shares-fall':'') }">${Math.abs(data.f30)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f30'
                    }
                },
                {
                    name: 'je',
                    title: '金额',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.formatAmount(data.f6,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f6'
                    }
                },
                // {
                //     name: 'hs',
                //     title: '换手',
                //     html: function (data) {
                //         if (data == null) {
                //             return `<th class="sort_normal">${this.title}</th>`
                //         } else {
                //             return `<td>${self.formatNum(data.f8,data.f152,data.f152,'%')}</td>`
                //         }
                //     },
                //     sort: true,
                //     sortitem: {
                //         desvalue: '1',
                //         ascvalue: '0',
                //         key: 'f8'
                //     }
                // },
                {
                    name: 'lb',
                    title: '量比',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.formatNum(data.f10,data.f152,data.f152)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f10'
                    }
                },
                {
                    name: 'zg',
                    title: '最高',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f15 > data.f18 ? 'shares-rise' : (data.f15 < data.f18?'shares-fall':'') }">${self.formatNum(data.f15,data.f1,3)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f15'
                    }
                },
                {
                    name: 'zd',
                    title: '最低',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f16 > data.f18 ? 'shares-rise' : (data.f16 < data.f18?'shares-fall':'') }">${self.formatNum(data.f16,data.f1,3)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f16'
                    }
                },
            ]
        })
        quotetable.init()
        return quotetable
    },
    mobileSelectInit:function(){
        var self = this;
        var mobileSelect1 = new MobileSelect({
            trigger: '#trigger',// 点击容器的ID
            title: '单项选择',// 
            wheels: [
                { data: ['全部REITs','上交所REITs','深交所REITs'] }
            ],
            position: [2],
            defaultselect:1,
            callback: function (index,data) {
                self.pz_size = 10
                $('.hsphb-more').html('查看更多<i class="arrow-down"></i>')
                self.fs_index = self.quoteConfig.fs[index-1]
                $("#market-title").html(data)
                // 取消旧市场定时刷新
                self.table.destroy()
                // 重新生成列表
                self.table = self.makeQuoteTable()
            }
        });
    },
    formatZS(num: number, isSign: boolean) {
        let numSign: string
        let self = this
        if (isSign) {
          if (num < 0) {
            numSign = '-'
          } else if (num == 0) {
            numSign = ''
          } else {
            numSign = ''
          }
        } else {
          numSign = ''
        }
        if (Math.abs(num) == 0) {
          return 0
        } else if (Math.abs(num) > 0 && Math.abs(num) < 100000) {
          return numSign + self.formatNum(Math.abs(num), 0, 0)
        } else if (Math.abs(num) >= 100000 && Math.abs(num) < 1000000) {
            return numSign + self.formatNum(Math.abs(num) / 10000, 0, 1, '万')
        } else if (Math.abs(num) >= 1000000) {
            return numSign + self.formatNum(Math.abs(num) / 10000, 0, 0, '万')
        }else{
            return '-'
        }
    },
    formatAmount(num: number, isSign: boolean) {
        let numSign: string
        let self = this
        if (isSign) {
          if (num < 0) {
            numSign = '-'
          } else if (num == 0) {
            numSign = ''
          } else {
            numSign = ''
          }
        } else {
          numSign = ''
        }
        if (Math.abs(num) == 0) {
          return 0
        } else if (Math.abs(num) > 0 && Math.abs(num) < 100000) {
          return numSign + self.formatNum(Math.abs(num), 0, 0)
        } else if (Math.abs(num) >= 100000 && Math.abs(num) < 100000000) {
            return numSign + self.formatNum(Math.abs(num) / 10000, 0, 0, '万')
        } else if (Math.abs(num) >= 100000000) {
            return numSign + self.formatNum(Math.abs(num) / 100000000, 0, 2, '亿')
        }else{
            return '-'
        }
    },
    formatNum(value: any, rate: number, tofixed: number, suffix = "") {
        if (value == "-" || value == undefined || isNaN(value)) return value
        let num = Number(value)
        let r = Number(rate)
        let temp = Math.pow(10, r)
      
        if (num) {
          return (num / temp).toFixed(tofixed) + suffix
        } else {
          return num.toFixed(tofixed) + suffix
        }
    },
}

data.init()


import {NavScroll} from '../modules/title_scroll'
NavScroll("nav_reits")